/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/href-no-hash */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

const SiteWrapper = ({ children }) => (
  <div id="wrapper">
    <header id="header">
      <div className="container">
        <div className="nav-wrapper">
          <div className="top-panel">
            <strong className="logo">
              <NavLink href="/" to="/" className="brand-logo">
                <img src="/images/logo.png" alt="BlockCAT" />
              </NavLink>
            </strong>
            <a href="#" className="nav-opener">
              <span>Menu</span>
            </a>
            <div className="topmenu-wraper">
              <ul className="icon-bar">
                <li>
                  <a href="#" className="has-new">
                    <i className="icon-bell" />
                  </a>
                </li>
              </ul>
              <ul className="profile-links">
                <li>
                  <a href="#">
                    <span className="user-pic">
                      <img src="/images/user-pic.png" alt="user profile" />
                    </span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="icon-dots-vertical" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="nav-drop">
            <a href="#" className="nav-opener">
              <span>Menu</span>
            </a>
            <div className="drop-inner">
              <ul className="main-menu">
                <li>
                  <NavLink href="/" to="/">
                    <i className="icon-payment" /> Create
                  </NavLink>
                </li>
                <li>
                  <NavLink href="/contracts" to="/contracts">
                    <i className="icon-dashboard" /> Manage
                  </NavLink>
                </li>
                <li>
                  <a href="#">
                    <i className="icon-deposit" /> Wallet
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="icon-faq" /> FAQ
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i className="icon-support" /> Support
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main id="main">
      <div className="page-holder">
        <div className="container">{children}</div>
      </div>
    </main>
    <footer className="page-footer" id="footer">
      <div className="footer-copyright">
        <div className="container">
          <div className="row row-md-flex align-center">
            <div className="col m4 s12">
              <span className="copyright-text">
                &copy; {new Date().getFullYear()} <a href="https://blockcat.io">BlockCAT</a>
              </span>
            </div>
            <div className="col m8 s12">
              <ul className="footer-list">
                <li>
                  <a href="#">ABOUT</a>
                </li>
                <li>
                  <a href="#">CONTACT US </a>
                </li>
                <li>
                  <a href="#">TERMS OF USE</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
);

SiteWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SiteWrapper;



// WEBPACK FOOTER //
// ./src/SiteWrapper.js